import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Meta } from '@angular/platform-browser';
import { Location } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {

  constructor(
    private router: Router,
    private metaService: Meta,
    private location: Location
  ) {}

  ngOnInit() {

    this.router.events.subscribe((evt) => {
      // scroll to top on routes changes
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts